/**
 * Gamla kommunslugar från tidigare Elmarknad.se (genitivform m.m.)
 * mappade till de slugar sajten använder idag. Används för 301-omdirigering
 * så att indexerade URL:er behåller sitt länkvärde.
 */
export const legacyMunicipalitySlugs: Record<string, string> = {
  "almhults": "almhult",
  "alvdalens": "alvdalen",
  "alvsbyns": "alvsbyn",
  "amals": "amal",
  "angelholms": "angelholm",
  "arjangs": "arjang",
  "arjeplogs": "arjeplog",
  "arvidsjaurs": "arvidsjaur",
  "askersunds": "askersund",
  "astorps": "astorp",
  "atvidabergs": "atvidaberg",
  "bastads": "bastad",
  "bergs": "berg",
  "bjurholms": "bjurholm",
  "bjuvs": "bjuv",
  "bodens": "boden",
  "bollebygds": "bollebygd",
  "borgholms": "borgholm",
  "boxholms": "boxholm",
  "burlovs": "burlov",
  "dals-eds": "dals-ed",
  "danderyds": "danderyd",
  "enkopings": "enkoping",
  "eslovs": "eslov",
  "falkenbergs": "falkenberg",
  "falkopings": "falkoping",
  "falu": "falun",
  "filipstads": "filipstad",
  "finspangs": "finspang",
  "flens": "flen",
  "gagnefs": "gagnef",
  "gislaveds": "gislaved",
  "goteborgs": "goteborg",
  "gotlands": "gotland",
  "grastorps": "grastorp",
  "gullspangs": "gullspang",
  "hallsbergs": "hallsberg",
  "hallstahammars": "hallstahammar",
  "halmstads": "halmstad",
  "harjedalens": "harjedalen",
  "harnosands": "harnosand",
  "hassleholms": "hassleholm",
  "helsingborgs": "helsingborg",
  "hoors": "hoor",
  "hudiksvalls": "hudiksvall",
  "hultsfreds": "hultsfred",
  "jokkmokks": "jokkmokk",
  "jonkopings": "jonkoping",
  "karlsborgs": "karlsborg",
  "karlshamns": "karlshamn",
  "karlstads": "karlstad",
  "katrineholms": "katrineholm",
  "kils": "kil",
  "klippans": "klippan",
  "kopings": "koping",
  "kramfor": "kramfors",
  "kristianstads": "kristianstad",
  "kristinehamns": "kristinehamn",
  "krokoms": "krokom",
  "kungalvs": "kungalv",
  "kungsors": "kungsor",
  "laholms": "laholm",
  "lekebergs": "lekeberg",
  "leksands": "leksand",
  "lerums": "lerum",
  "lidkopings": "lidkoping",
  "lilla-edets": "lilla-edet",
  "lindesbergs": "lindesberg",
  "linkopings": "linkoping",
  "ljusdals": "ljusdal",
  "ljusnarsbergs": "ljusnarsberg",
  "lunds": "lund",
  "lysekils": "lysekil",
  "malung-salens": "malung-salen",
  "mariestads": "mariestad",
  "markaryds": "markaryd",
  "marks": "mark",
  "melleruds": "mellerud",
  "molndals": "molndal",
  "munkedals": "munkedal",
  "norbergs": "norberg",
  "nordanstigs": "nordanstig",
  "nordmalings": "nordmaling",
  "norrkopings": "norrkoping",
  "nykopings": "nykoping",
  "nykvarns": "nykvarn",
  "nynashamns": "nynashamn",
  "odeshogs": "odeshog",
  "olofstroms": "olofstrom",
  "ornskoldsviks": "ornskoldsvik",
  "orusts": "orust",
  "oskarshamns": "oskarshamn",
  "osterakers": "osteraker",
  "ostersunds": "ostersund",
  "osthammars": "osthammar",
  "ovanakers": "ovanaker",
  "oxelosunds": "oxelosund",
  "perstorps": "perstorp",
  "rattviks": "rattvik",
  "salems": "salem",
  "sandvikens": "sandviken",
  "saters": "sater",
  "simrishamns": "simrishamn",
  "skinnskattebergs": "skinnskatteberg",
  "skurups": "skurup",
  "smedjebackens": "smedjebacken",
  "soderhamns": "soderhamn",
  "soderkopings": "soderkoping",
  "solvesborgs": "solvesborg",
  "staffanstorps": "staffanstorp",
  "stenungsunds": "stenungsund",
  "stockholms": "stockholm",
  "storumans": "storuman",
  "stromstads": "stromstad",
  "stromsunds": "stromsund",
  "sundbybergs": "sundbyberg",
  "sundsvalls": "sundsvall",
  "surahammars": "surahammar",
  "svalovs": "svalov",
  "tanums": "tanum",
  "tidaholms": "tidaholm",
  "tierps": "tierp",
  "tingsryds": "tingsryd",
  "tjorns": "tjorn",
  "trelleborgs": "trelleborg",
  "trollhattans": "trollhattan",
  "ulricehamns": "ulricehamn",
  "vaggeryds": "vaggeryd",
  "valdemarsviks": "valdemarsvik",
  "vanersborgs": "vanersborg",
  "varbergs": "varberg",
  "vasterviks": "vastervik",
  "vaxholms": "vaxholm",
  "vindelns": "vindeln",
  "vingakers": "vingaker",
  "ystads": "ystad",
};

/** Returnerar den aktuella kommunsluggen för en (eventuellt gammal) slug. */
export function resolveMunicipalitySlug(slug: string): string {
  return legacyMunicipalitySlugs[slug.toLowerCase()] ?? slug;
}
